import React, { useEffect } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useSubjects } from './SubjectContext';

const SubjectLesson: React.FC = () => {
  const { subjectId } = useParams();
  const [params] = useSearchParams();
  const { catalogue, visible, activeId, switchSubject } = useSubjects();
  const subject = catalogue.find((item) => item.id === subjectId);
  const enrolled = visible.some((item) => item.id === subjectId);

  useEffect(() => {
    if (subject && enrolled && subject.id !== activeId) switchSubject(subject.id);
  }, [subject, enrolled, activeId, switchSubject]);

  if (!subject) {
    return <p className="p-10 text-center text-gray-600">Loading…</p>;
  }

  const diagnostic = params.get('mode') === 'diagnostic';
  const firstTopic = subject.units[0]?.topics[0] ?? subject.name;

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10 dark:bg-gray-900">
      <div className="mx-auto max-w-xl rounded-lg bg-white shadow dark:bg-gray-800">
        <div className="rounded-t-lg px-6 py-4 text-white" style={{ backgroundColor: subject.colour }}>
          <p className="text-sm uppercase tracking-wide text-white/80">{subject.name}</p>
          <h1 className="text-2xl font-bold">{diagnostic ? 'Short diagnostic' : `Lesson 1. ${firstTopic}`}</h1>
        </div>
        <div className="space-y-4 p-6">
          {subject.placeholder && (
            <p className="rounded-lg bg-yellow-50 p-3 text-sm text-yellow-800">
              Placeholder. {subject.name} lessons and diagnostic questions are not written yet.
            </p>
          )}
          <p className="text-gray-700 dark:text-gray-300">
            {diagnostic
              ? 'The diagnostic will ask a few questions from each unit and place you at the right starting point.'
              : `You are starting at Unit 1. ${subject.units[0]?.title ?? ''}`}
          </p>
          <Link
            to="/dashboard"
            className="inline-block rounded-lg px-4 py-2 font-semibold text-white"
            style={{ backgroundColor: subject.colour }}
          >
            Go to {subject.name} home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubjectLesson;
